import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-802 (Phase 5 / Sub-phase 8 / S8-WB1).
 * The `logFrontendEvent` callable is intentionally left in place for rollback
 * until the Sub-phase 9 retirement sweep.
 */
export const logFrontendEventRoute = {
  transport: 'api',
  method: 'POST',
  path: '/telemetry/frontend-event',
} as const satisfies BackendRouteDefinition;
